























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  コード入力候補検索条件型,
  コード入力検索結果一覧型,
  コード入力検索結果型,
  コード入力発注候補型,
  発注卸型,
  発注未確定登録レコード型,
  発注未確定登録型,
  発注未確定登録結果型,
  発注未確定重複レコード型,
} from '@/type/purchaseorder/item';
import {マスタ選択区分型, 商品オンライン発注可否区分, 発注入力方法区分型, 発注未確定登録区分, 発注未確定登録結果区分, 発注重複表示区分} from '@/type/purchaseorder/types';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import {loginModule} from '@/store/authentication/login';

import {ValidationResult} from '@/type/validation/result';
import {コード入力検索条件バリデータ一覧, 発注情報バリデータ一覧} from '@/type/purchaseorder/order-validate';

import AmountField from '@/components/atom/input/AmountField.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import WholesaleSelectorPurchaseOrder from '@/components/wholesale/WholesaleSelectorPurchaseOrder.vue';
import DuplicateWarningDialog from '@/views/purchaseorder/DuplicateWarningDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
    components: {
      AmountField,
      NormalDialog,
      WholesaleSelectorPurchaseOrder,
      DuplicateWarningDialog,
      ConfirmDialog,
      NormalButton,
    },
  })

  export default class CodeInputDialog extends Vue {
    private コード入力候補検索条件: コード入力候補検索条件型 = this.検索条件初期値を取得();
    private コード入力検索結果商品: コード入力発注候補型[] = [];
    private 発注候補商品リスト: コード入力発注候補型[] = [];
    private 発注未確定登録リスト: 発注未確定登録レコード型[] = [];
    private 発注重複商品リスト: 発注未確定重複レコード型[] = [];

    private 選択中の行index: number | null = null;
    private beforeOpened: boolean = false;

    private グリッド最終行: number | null = null;

    private 警告画面表示: boolean = false;
    private 警告画面表示モード: string = 発注重複表示区分.発注未確定登録;

    private 検索条件バリデーション結果: ValidationResult = new ValidationResult(コード入力検索条件バリデータ一覧);
    private 発注候補バリデーション結果: ValidationResult = new ValidationResult(発注情報バリデータ一覧);
    private 発注未確定登録バリデーション結果: ValidationResult = new ValidationResult(発注情報バリデータ一覧);

    private 重複した商品: boolean = false;

    @Prop({default: false})
    private modal!: boolean;

    @Prop({default: []})
    private wholesaleList!: 発注卸型[];

    @Watch('発注候補商品リスト.JANコード', {deep: true})
    private 数量にフォーカス(): void {
      this.$nextTick(() => {
        this.グリッド最終行 = (this.件数を取得()) - 1;
        if (this.グリッド最終行 >= 0) {
          this.入力欄を指定().数量入力欄[this.グリッド最終行].$el.childNodes[0].focus();
          this.リスト選択時の処理(this.グリッド最終行);
        }
      });
    }

  private beforeOpen() {
    const JANGTIN入力欄 = document.getElementById('JANGTIN入力欄');
    if (JANGTIN入力欄) {
      JANGTIN入力欄.focus();
    }
    this.beforeOpened = true;
  }

    private beforeUpdate(): void {
      this.検索条件バリデーション結果.validate(this.コード入力候補検索条件);
      this.発注候補バリデーション結果.validateList(this.発注候補商品リスト);
    }

    private 検索条件入力エラー判定表示(項目名: string) {
      return {'input-error': this.検索条件バリデーション結果.hasError(項目名)};
    }

    private 発注候補エラー判定(index: number, 項目名: string): boolean {
      return this.発注候補バリデーション結果.hasError(項目名, index);
    }

    private async 確定するハンドラ() {
      await progress(this.確定する);
    }

    private async 確定する(): Promise<void> {
      this.発注未確定登録リスト = this.発注候補商品リスト
        .filter((発注候補商品: コード入力発注候補型) => {
          return 発注候補商品.選択 === true;
        })
        .map((発注候補商品: コード入力発注候補型) => {
          return {
            JANコード: 発注候補商品.JANコード,
            販売GTINコード: 発注候補商品.販売GTINコード,
            備蓄商品コード: 発注候補商品.備蓄商品コード,
            商品コード: 発注候補商品.商品コード,
            商品区分: 発注候補商品.商品区分,
            卸コード: 発注候補商品.卸コード,
            発注数: 発注候補商品.発注数,
            発注方法区分: null,
            採用フラグ: 発注候補商品.採用フラグ,
            オンライン発注可否区分: 発注候補商品.オンライン発注可否区分,
            発注入力方法区分: 発注入力方法区分型.商品追加,
            発注伝票番号: null,
            発注伝票行番号: null,
          };
        });

      if (this.発注未確定登録リスト.length === 0) {
        this.$emit('show-alert', '発注する商品が選択されていません');
        return;
      }

      this.発注未確定登録バリデーション結果.validateList(this.発注未確定登録リスト);
      if (this.発注未確定登録バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.発注未確定登録バリデーション結果.getMessages());
        return;
      }

      const 発注未確定登録依頼: 発注未確定登録型 = {
        発注未確定登録方法区分: 発注未確定登録区分.重複確認して登録する,
        発注未確定登録レコードリスト: this.発注未確定登録リスト,
      };

      await api.発注候補商品を登録する(発注未確定登録依頼)
        .then((response: 発注未確定登録結果型) => {
          if (response.発注未確定登録結果区分 === 発注未確定登録結果区分.重複登録あり) {
            this.発注重複商品リスト = response.発注未確定重複リスト;
            this.警告画面表示 = true;
          } else {
            this.beforeOpened = false;
            this.$modal.hide('発注コード入力画面');
            this.$emit('finish-code-search');
          }
        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }

    private async 重複ありで確定するハンドラ() {
      await progress(this.重複ありで確定する);
    }

    private async 重複ありで確定する(): Promise<void> {
      this.警告画面表示 = false;

      const 発注未確定登録依頼: 発注未確定登録型 = {
        発注未確定登録方法区分: 発注未確定登録区分.登録する,
        発注未確定登録レコードリスト: this.発注未確定登録リスト,
      };

      await api.発注候補商品を登録する(発注未確定登録依頼)
        .then((response: 発注未確定登録結果型) => {
          this.beforeOpened = false;
          this.$modal.hide('発注コード入力画面');
          this.$emit('finish-code-search');

        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }

    private 確認画面に戻る() {
      this.警告画面表示 = false;
      this.発注重複商品リスト = [];
    }

    private 戻る() {
      this.警告画面表示 = false;
      this.beforeOpened = false;
      this.$modal.hide('発注コード入力画面');
      this.$emit('finish-code-search');
    }

    private 商品のオンライン発注不可(発注候補: コード入力発注候補型): boolean {
      return 発注候補.オンライン発注可否区分 !== 商品オンライン発注可否区分.発注可能;
    }

    @Watch('modal')
    private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
      if (nowModal === true) {
        this.発注候補商品リスト = [];
        this.発注未確定登録リスト = [];
        this.コード入力候補検索条件 = this.検索条件初期値を取得();
        this.警告画面表示 = false;
        this.発注重複商品リスト = [];
        this.選択中の行index = null;
        this.重複した商品 = false;
        this.$modal.show('発注コード入力画面');
      }
    }

    private 検索条件初期値を取得(): コード入力候補検索条件型 {
      return {
        JANコードまたは販売GTINコード: '',
      };
    }

    private async 検索するハンドラ(keyCode: number, repeat: boolean) {
      if (keyCode !== 13) return;
      if (repeat === true) return;
      if (this.検索条件バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.検索条件バリデーション結果.getMessages());
        return;
      }

      await progress(this.検索する);
    }

    private async 検索する(): Promise<void> {
      if (this.コード入力候補検索条件.JANコードまたは販売GTINコード.length < 1) {
        this.$emit('show-alert', 'JAN/販売GTINコードは入力が必須です');
        return;
      }

      await api.コード入力候補を検索する(this.コード入力候補検索条件)
        .then((response: コード入力検索結果一覧型) => {
          this.コード入力検索結果商品 = response.コード入力検索結果レコードリスト.map((取得商品: コード入力検索結果型) => {
            return {
              選択: true,
              採用フラグ: 取得商品.採用フラグ,
              商品区分: 取得商品.商品区分,
              メーカー名: 取得商品.メーカー名,
              商品名: 取得商品.商品名,
              規格容量: 取得商品.規格容量,
              発注数: 取得商品.発注数,
              卸コード: 取得商品.卸コード,
              商品コード: 取得商品.商品コード,
              JANコード: 取得商品.JANコード,
              販売GTINコード: 取得商品.販売GTINコード,
              備蓄商品コード: 取得商品.備蓄商品コード,
              オンライン発注可否区分: 取得商品.オンライン発注可否区分,
              採用区分: 取得商品.採用区分,
              卸選択不可: (取得商品.採用区分 === '採用' || 取得商品.採用区分 === '採用(外)') && 取得商品.卸コード !== null,
              経過措置区分: 取得商品.経過措置区分,
            };
          });

          if (this.コード入力検索結果商品.length === 0) {
            this.$emit('show-alert', '商品が見つかりませんでした');
          }

          this.重複した商品 = this.重複商品のチェック();

          this.発注候補商品リスト = this.発注候補商品リスト.concat(this.コード入力検索結果商品);

        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }

    private async リスト選択時の処理(index: number) {
      this.選択中の行index = index;
    }

    private 行が選択されている(index: number) {
      return this.選択中の行index === index;
    }

    private ダイアログを開く(name: string): void {
      this.$modal.show(name);
    }

    private ダイアログを閉じる(name: string): void {
      this.$modal.hide(name);
    }

    private JANGTINにフォーカス(keyCode: number, repeat: boolean): void {
      if (keyCode !== 13) return;
      if (repeat === true) return;
      this.コード入力候補検索条件 = this.検索条件初期値を取得();
      this.入力欄を指定().JANGTIN入力欄.focus();
    }

    private 入力欄を指定(): any {
      return this.$refs;
    }

    private 件数を取得() {
      return this.発注候補商品リスト.length;
    }

    private 重複商品のチェック(): boolean {
      for (const index in this.発注候補商品リスト) {
        if (this.発注候補商品リスト[index].JANコード === this.コード入力検索結果商品[0].JANコード) {
          return true;
        }
      }
      return false;
    }

    private 経過措置状態クラス(index: number, 発注候補商品: コード入力発注候補型): string {
      if (this.行が選択されている(index)) {
        return 'selected';
      }
      if (発注候補商品.経過措置区分 === '経過措置期間') {
        return '経過措置期間';
      }
      if (発注候補商品.経過措置区分 === '経過措置終了') {
        return '経過措置終了';
      }
      return '';
    }
  }

